import BaseStore from 'customer-flows/stores/base-store'
import { trackedAsync, type Awaitable } from 'customer-flows/utils/core'

export default class AccountStoreClass extends BaseStore {
  @trackedAsync() account: Awaitable<Account>

  get name (): string | undefined {
    return this.account.value?.name
  }

  get id (): string | undefined {
    return this.account.value?.id
  }

  get timezone(): string | undefined {
    return this.account.value?.timezone
  }

  get enabledFeatureFlags (): EnabledFeatureFlags[] | undefined {
    return this.account.value?.enabledFeatureFlags
  }

  get availabilityBrandingConfig (): AvailabilityBrandingConfig | undefined {
    return this.account.value?.availabilityBrandingConfig
  }

  get theme (): AVAILABLE_THEMES | undefined {
    return this.availabilityBrandingConfig?.theme
  }

  get headerStyle (): BrandingHeaderStyle | undefined {
    return this.availabilityBrandingConfig?.headerStyle
  }

  get headerText (): string | undefined {
    return this.availabilityBrandingConfig?.headerText
  }

  get headerLogoUrl (): string | undefined {
    return this.availabilityBrandingConfig?.headerLogoUrl
  }

  get defaultPaymentProcessor (): PaymentProcessor | undefined {
    return this.account.value?.defaultPaymentProcessor
  }

  get stripeData (): { publishableKey?: string; accountId?: string; type?: string } | undefined {
    const processor = this.defaultPaymentProcessor
    if (!processor || !processor.type.includes('STRIPE')) {
      return undefined
    }

    // Handle the aliased accountId field for STRIPE_CONNECT (non-nullable)
    // All other types use the regular accountId field (nullable)
    let accountId: string | undefined
    const processorAny = processor as any

    if (processor.type === 'STRIPE_CONNECT') {
      accountId = processorAny.stripeConnectAccountId
    } else {
      accountId = processorAny.accountId
    }

    return {
      publishableKey: processorAny.publishableKey,
      accountId,
      type: processor.type
    }
  }

  isFeatureEnabled(flag: EnabledFeatureFlags): boolean {
    return this.enabledFeatureFlags?.includes(flag) ?? false
  }
}

declare global {
  export type AccountStore = AccountStoreClass
  export interface StoreRegistry {
    account: AccountStore
  }
}
